import { render } from "./IndexMouvement.vue?vue&type=template&id=f4cc2050"
import script from "./IndexMouvement.vue?vue&type=script&lang=js"
export * from "./IndexMouvement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__